<template>
  <div 
    :class="className" 
    class="input-group date">
    <input 
      :name="name"
      :disabled="disabled"
      :placeholder="placeholder"
      :required="required"
      :class="inputClass"
      type="text"
      data-parsley-datetime=""
      class="has-value" >
    
    <span class="input-group-addon">
      <span class="fa fa-calendar"/>
    </span>
  </div>
</template>

<script>
const events = ['hide', 'show', 'change', 'error', 'update'];

export default {
    props: {
        name: {
            type: String,
            default: '',
        },

        className: {
            type: String,
            default: '',
        },

        inputClass: {
            type: String,
            default: 'md-input',
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        placeholder: {
            type: String,
            default: '',
        },

        required: {
            type: Boolean,
            default: false,
        },

        config: {
            type: Object,
            default: () => ({
                format: 'YYYY-MM-DD hh:mm A',
            }),
        },

        // eslint-disable-next-line vue/require-prop-types
        value: {
            default: null,
            required: true,
            validator(value) {
                return (
                    value === null ||
                    value instanceof Date ||
                    typeof value === 'string' ||
                    value instanceof String ||
                    value instanceof moment
                );
            },
        },
    },

    data() {
        return {
            dp: null,
            elem: null,
            textvalue: null,
        };
    },

    watch: {
        /**
         * Listen to change from outside of component and update DOM
         *
         * @param newValue
         */
        value(newValue) {
            // Prevent dp-change being triggered multiple times
            // if (newValue === this.value) return;
            // Notify datepicker that there is a change in date
            this.dp && this.dp.date(newValue || null);
        },
    },

    mounted() {
        if (this.dp) return;
        // Handle wrapped input
        let node = this.$el;
        // Cache DOM
        this.elem = jQuery(node);
        // Init date-picker
        this.elem.datetimepicker(this.config);
        // Store data control
        this.dp = this.elem.data('DateTimePicker');
        // Set initial value
        this.dp.date(this.processInitialValue(this.value));
        // Watch for changes
        this.elem.on('dp.change', this.onChange);
        // Register remaining events
        this.registerEvents();

        this.registerInputClickEvent();
    },
    beforeDestroy() {
        // Free up memory
        if (this.dp) {
            this.dp.destroy();
            this.dp = null;
            this.elem = null;
        }
    },

    methods: {
        onChange(event) {
            let date = event.date || null;

            this.$emit('input', date);

            if (date !== null) {
                this.textvalue = date.format(this.config.format);
            } else {
                this.textvalue = null;
            }
        },

        registerInputClickEvent() {
            this.elem.click(e => {
                this.dp.show();
            });
        },

        registerEvents() {
            events.forEach(name => {
                this.elem.on('dp.' + name, (...args) => {
                    this.$emit('dp-' + name, ...args);
                });
            });
        },

        processInitialValue(value) {
            if (typeof value === 'string' || value instanceof String) {
                return moment(value);
            }

            return value;
        },
    },
};
</script>
